var treeButtonContainers = document.getElementsByClassName('tree-button-container');

//pop up the modal if the button is clicked
if (treeButtonContainers != null) {
	for (let i = 0; i < treeButtonContainers.length; i++) {
		var container = treeButtonContainers[i];
		var button = container.getElementsByTagName('button')[0];
		button.addEventListener('click', function () {
			var id = this.id;
			var modal = document.getElementById('tree_finder_' + id + '_popup');
			modal.classList.remove('hidden');
		})
	}
}

//if the area overlay area is clicked hide the modal again
var overlays = document.getElementsByClassName('overlay');
if (overlays != null) {
	for (let i = 0; i < overlays.length; i++) {
		overlays[i].addEventListener('click', function () {
			this.parentNode.classList.add('hidden');
		})
	}
}

function hideAllModals() {
	var overlays = document.getElementsByClassName('overlay');
	if (overlays != null) {
		for (let i = 0; i < overlays.length; i++) {
			overlays[i].parentNode.classList.add('hidden');
		}
	}
}

//need to wrap in this event listener to get it to work
document.addEventListener('facetwp-loaded', function () {
	colorTreeContainerButtons()
	hideAllModals()
});

document.addEventListener('facetwp-refresh', function () {
	colorTreeContainerButtons()

});

//if any of the options are selected for that filter the button needs to show this
function colorTreeContainerButtons() {
	if (treeButtonContainers != null) {
		for (let i = 0; i < treeButtonContainers.length; i++) {
			var container = treeButtonContainers[i];
			//find out what the button id is so we can find the right filter
			var buttonID = container.getElementsByTagName('button')[0].id;
			//find the facet
			var facet = document.getElementsByClassName('facetwp-facet-tree_finder_' + buttonID)[0];
			//find all the children with the class 'checked'
			if (facet != null) {
				var checkedChildren = facet.getElementsByClassName('checked');
				if (checkedChildren != null) {
					if (checkedChildren.length > 0) {
						container.classList.add('active');
					} else {
						if (container.classList.contains('active')) {
							container.classList.remove('active');
						}
					}
				}
			}
		}
	}
}
